import classNames from 'classnames/bind'
import { stationsListPricingOperations } from 'config/apollo/stations-list-pricing/operations'
import PropTypes from 'prop-types'
import React from 'react'
import { PolePriceCell } from './components/pole-price-cell'
import { FuelGradeDifferentials } from './components/fuel-grade-differentials'
import styles from './PolePriceRow.module.scss'

const cx = classNames.bind(styles)

const PolePriceRow = ({
  stationName,
  fuelGrades,
  pricing,
  isFirstRow,
  isFiltered,
}) => {
  const {
    stationId,
    polePrices,
    priceDifferentials: { fuelGradeDifferentials },
    priceChangeEnabled,
  } = pricing

  const handleIncrementClick = fuelGradeId => {
    stationsListPricingOperations.incrementStationPriceChange(
      stationId,
      fuelGradeId,
      polePrices,
      fuelGradeDifferentials
    )
  }

  const handleDecrementClick = fuelGradeId => {
    // In the stations table, price changes can only apply to 'cash', 'credit', or 'both' together.
    // This means the first matching item in polePrices will always represent the effective price.
    // Users cannot update 'cash' and 'credit' prices independently — it's either one or both with the same value.
    
    const currentPrice = pricing.polePrices.filter(polePrice => polePrice.fuelGradeId === fuelGradeId)[0].price // This is the current price of the fuel grade
    let priceChange = 0 // This is the price change being requested
    if(pricing.priceChanges.length > 0) {
      priceChange = pricing.priceChanges.filter(priceChange => priceChange.fuelGradeId === fuelGradeId)[0].priceChange
    }

    // Prevent decrementing priceChange further if it would result in a negative price
    if(priceChange < 0 && currentPrice + priceChange < 2) return

    stationsListPricingOperations.decrementStationPriceChange(
      stationId,
      fuelGradeId,
      polePrices,
      fuelGradeDifferentials
    )
  }

  return (
    <div
      className={cx('pole-prices-row', {
        'first-row': isFirstRow,
        filtered: isFiltered,
      })}
      data-testid="pole-prices-row"
    >
      <FuelGradeDifferentials
        stationName={stationName}
        priceChangeEnabled={priceChangeEnabled}
        fuelGrades={fuelGrades}
        fuelGradeDifferentials={fuelGradeDifferentials}
      />
      {fuelGrades.map(fuelGrade => (
        <PolePriceCell
          key={fuelGrade.id}
          fuelGrade={fuelGrade}
          pricing={pricing}
          handleIncrementClick={handleIncrementClick}
          handleDecrementClick={handleDecrementClick}
        />
      ))}
    </div>
  )
}

PolePriceRow.propTypes = {
  stationName: PropTypes.string.isRequired,
  fuelGrades: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  pricing: PropTypes.shape().isRequired,
  isFirstRow: PropTypes.bool.isRequired,
  isFiltered: PropTypes.bool.isRequired,
}

export { PolePriceRow }
